import { h, Fragment } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import register from "preact-custom-element";
import useProducts from "../helpers/useProduct/useProducts";
import ShoppableImageProduct from "./shoppable-image-product";

function ShoppableImageProducts({ handles }) {
  const containerRef = useRef(null);
  const products = useProducts(handles.split(","), "handle");

  useEffect(() => {
    const hostElement = containerRef.current?.closest(
      "shoppable-image-products",
    );

    if (hostElement) {
      hostElement.classList.toggle("visually-hidden", !products.length);
    }
  }, [products.length]);

  if (!products.length) return null;

  return (
    <div ref={containerRef} className="shoppable-image-products__products">
      {products
        .slice(0, 3)
        .map((product) =>
          product ? (
            <ShoppableImageProduct
              product={product}
              key={product.id}
            ></ShoppableImageProduct>
          ) : null,
        )}
    </div>
  );
}

if (!customElements.get("shoppable-image-products")) {
  register(
    ShoppableImageProducts,
    "shoppable-image-products",
    ["src", "alt", "handles"],
    {
      shadow: false,
    },
  );
}
